<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <Dialog
        :visible.sync="printDialog"
        header="Do you want to print this bill?"
        :style="{width: '35vw'}"
        :modal="true"
      >
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-2">
            <Button class="p-button-raised p-button-rounded" @click="printBill" label="Yes"/>
            <Button class="p-button-danger" @click="closePrintDialog" label="No"/>
          </div>
        </div>
      </Dialog>
      <Dialog header="Latest Last Rate" :modal="true" :visible.sync="salesRateDetails"
              :style="{width: '60vw'}" :closable=true :contentStyle="{'overflow': 'scroll'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12">
            <DataTable :value="latestSalesRateList" class="editable-cells-table">
              <Column header="Date" field="nepaliDate"/>
              <Column header="Bill No" field="billNo"/>
              <Column header="voucher" field="voucher"/>
              <Column header="Quantity" field="outQuantity"/>
              <Column header="Rate" field="price"/>
            </DataTable>
          </div>
        </div>
        <template #footer>
          <Button label="Cancel" @click="closeSalesRatesLatest" class="p-button-danger"/>
        </template>
      </Dialog>
      <Dialog header="Varients Details" :modal="true"
              :visible.sync="displayVarientsDialog"
              :closable=true :style="{width: '50vw'}" :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12">
            <DataTable :value="variantDetailslist" editMode="cell" class="editable-cells-table" ref="po">
              <Column field="propertyValue" header="Name" filterMatchMode="contains"></Column>
              <Column header="Pur Qty" field="quantity"></Column>
              <Column header="Avl Qty" field="avlQuantity"></Column>
              <Column header="Sales Qty" field="salesQuantity">
                <template #editor="slotProps">
                  <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2" :maxFracionDigits="4"/>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
        <Button @click.prevent="closeBasicBatchDetails" style="float:right" class="p-button-danger" label="Close"/>
      </Dialog>
      <form>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-lg-6 p-xl-2">
            <label>Date</label>
            <date-picker ref="tran" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" ref="tran" v-else class="nepali-calendar" id="purchaseSalesDate" v-model="purchaseSalesDate"/>
          </div>
          <div class="p-field p-col-12 p-lg-6 p-xl-2">
            <label for="billNo">Invoice No</label>
            <InputText id="billNo" v-model="billNo" disabled/>
          </div>
          <div class="p-field p-col-10 p-lg-2">
            <label for="paymentType">Sales Type</label>
            <select class="selectBox" v-model="taxType">
              <option selected disabled value="">Select Sales Type</option>
              <option v-for="(tax,ind) in taxTypeList" :key="ind">{{ tax.name }}</option>
            </select>
          </div>
          <div class="p-field p-col-12 p-lg-4 p-xl-2">
            <label for="loadFrom">Load From </label>
            <div class="radiobox">
              <div class="radiobox-itm">
                <label class="radio-inline">
                  <input type="radio" v-model="loadType" name="order" value="order" @change="loadFrom(loadType)"/>Order
                </label>
              </div>
              <div class="radiobox-itm">
                <label class="radio-inline">
                  <input type="radio" v-model="loadType" name="challan" value="challan" @change="loadFrom(loadType)"/>Challan
                </label>
              </div>
            </div>
          </div>
          <div class="p-field p-col-12 p-lg-3" v-if="loadFromOrder && !this.editing">
            <label for="OrderList" v-if="loadFromOrder && !this.editing"> Order List</label>
            <Dropdown
              v-model="orderId"
              :options="orderIdList"
              optionLabel="orderNoAndAccountName"
              :filter="true"
              @change="loadSalesOrderDataWithOrderNo(orderId.orderNo)"
              placeholder="Select Order"
            />
          </div>
          <div class="p-field p-col-12 p-lg-3" v-if="loadFromChallan && !this.editing">
            <label for="ChallanList" v-if="loadFromChallan && !this.editing"> Challan List</label>
            <Dropdown
              v-model="challanId"
              :options="challanIdList"
              optionLabel="orderNoAndAccountName"
              :filter="true"
              @change="loadSalesOrderDataWithChallanNo(challanId.challanNo)"
              placeholder="Select Chalan"
            />
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-10 p-lg-3">
            <label>Sale To</label>
            <Dropdown
              v-model="accountMaster"
              :options="supplierAndCustomerList"
              :filter="true"
              optionLabel="nameWithContact"
              placeholder="Select Account"
              :showClear="true"
              @change="getCreditLimitAmount"
            />
          </div>
          <div class="p-field p-col-2 p-lg-4 p-xl-1 align-self-end">
            <customerDialog v-tooltip.top="'Add Customer'" @set_customer_master="set_customer_master"/>
          </div>
          <div v-if="ifCash" class="p-field p-col-10 p-lg-3">
            <label>Customer</label>
            <Dropdown
              v-model="customer"
              :options="customerAccountList"
              optionLabel="name"
              :filter="true"
              placeholder="Select customer"
              :showClear="true"
            />
          </div>
          <div class="p-field p-col-2 p-lg-4 p-xl-1 align-self-end" v-if="ifCash">
            <customerDialog v-tooltip.top="'Add Customer'" @set_customer_master="set_customer_master"/>
          </div>
          <div class="p-fluid p-formgrid p-grid p-mt-2" v-show="accountMaster.id > 0">
            <div class="p-field p-col-12 p-md-4" v-if="accountMaster.id > 0">
              <label for="panNo">Tax No: </label>
              <b class="p-ml-1">{{ accountMaster.panNo }}</b>
            </div>
            <div class="p-field p-col-12 p-md-3" v-if="accountMaster.id > 0">
              <label for="panNo">Balance: </label>
              <b class="p-ml-4" style="color:red;" v-if="accountMaster.closingBalance>0">
                {{ (accountMaster.closingBalance).toFixed(2) + 'Cr' }}
              </b>
              <b class="p-ml-4" style="color:green;" v-else>
                {{ (accountMaster.closingBalance * (-1)).toFixed(2) + 'Dr' }}
              </b>
            </div>
          </div>
          <div class="p-field p-col-10 p-lg-2">
            <label for="warehouse">Store</label>
            <Dropdown
              v-if="!setWarehouseData"
              v-model="warehouse"
              :options="warehouseLists"
              :filter="true"
              optionLabel="name"
              placeholder="Select Warehouse"
              :showClear="true"
            />
            <Dropdown
              v-if="setWarehouseData"
              v-model="warehouse"
              :options="warehouseLists"
              :filter="true"
              optionLabel="name"
              placeholder="Select Warehouse"
              :disabled="true"
            />
          </div>
          <div class="p-field p-col-1 align-self-end">
            <warehouseDialog v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
          </div>
          <div class="p-field p-col-10 p-lg-1">
            <label for="warehouse">Credit Days</label>
            <InputNumber id="credit" v-model="creditDays" />
          </div>
        </div>
       
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-10 p-lg-8 p-xl-3">
            <label for="itm">Item<span style="color:red;">*</span></label>
            <AutoComplete v-model="item" v-if="!loadItemFromPurchase" filterMatchMode="contains"
                          :suggestions="filteredItems" @complete="searchItem($event)" filterType="contains"
                          field="name" ref="itm">
              <template #item="slotProps">
                <div style="font-size: 12px !important;">{{ slotProps.item.name }} - {{ slotProps.item.itemCode }}</div>
              </template>
            </AutoComplete>
            <AutoComplete v-model="item" v-else filterMatchMode='contains'
                          :suggestions="filterPurchase" @complete="searchPurchaseItem($event)"
                          field="itemToDisplayName" ref="itm">
            </AutoComplete>
          </div>
          <div class="p-field p-col-2 p-lg-4 p-xl-1 align-self-end">
            <itemDialog class="p-mt-5" v-tooltip.top="'Add Item'" @set_data_item="set_data_item"/>
          </div>
          <div class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="qty">Sales Qty</label>
            <InputNumber id="minmaxfraction" v-model="quantity" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div v-if="!item.multiUnit" class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="qty">Unit</label>
            <InputText type="text" class="form-control" v-model="item.unitName" disabled/>
          </div>
          <div v-if="item.multiUnit" class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="unit">Unit</label>
            <Dropdown
              v-model="alternateUnit"
              :options="item.itemMultiUnitDetailsDTOList"
              optionLabel="unitTo"
              :filter="true"
              placeholder="Select One"
              id="unit"
            />
          </div>
          <div v-if="item.multiUnit" class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="unit"></label>
            <Button class="p-button-rounded p-button-secondary" @click.prevent="openConversionDialog(unitConversion)" label="Detail"/>
          </div>
          <UniConversionDetail ref="conversionDialog"/>
          <div class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="rate">Rate</label>
            <InputNumber id="rate" v-model="rate" mode="decimal" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div  v-if="this.$store.getters.modules.includes('5.39')" class="p-field p-col-12 p-lg-3 p-xl-1">
            <label for="commissionPerItem">Commission</label>
            <InputNumber id="commissionPerItem" v-model="commissionPerItem" mode="decimal" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div class="p-field p-col-12 p-lg-3 p-xl-2">
            <label for="total">Total</label>
            <InputNumber v-if="$store.state.organisationid != 17" disabled id="minmaxfraction" v-model.lazy="total" :minFractionDigits="2" :maxFracionDigits="4"/>
            <InputNumber v-else id="minmaxfraction" @change="findRate" v-model="total" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div v-if="enableVarients" class="p-field p-col-12 p-lg-3 p-xl-2 align-self-center">
            <div class="radiobox">
              <div class="radiobox-itm">
                <Checkbox id="city2" name="city" v-model="displayVarientsDetails" :binary="true" @click.prevent="searchItemVariantDetails"/>
                <label for="city2">Varients Details</label>
              </div>
            </div>
          </div>
          <div class="p-field p-col-2 p-lg-4 p-xl-1 align-self-end">
            <Button class="p-button-raised" @click.prevent="addItemToDTOList" :label="!editDto?'Add':'Update'"/>
          </div>
          <div class="p-field p-col-2 p-lg-4 p-xl-1 align-self-end" v-if="editDto">
            <Button class="p-button-raised p-button-danger" @click="itemDTOreset" label="Cancel"/>
          </div>
          <div style="display:none;">{{ totalAmount }}</div>
          <div style="display:none;">{{ setRateFromItem }}</div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-8">
            <div class="p-fluid p-formgrid p-grid p-align-center h-100" v-if="item.id >0">
              <div class="p-field p-col-12 p-md-4 mb-0">
                <label for="avl">Cur. Stock:</label>
                <span>{{ item.closingStock }}</span>
              </div>
              <div class="p-field p-col-12 p-lg-2 p-xl-2 align-self-center">
                <div class="radiobox">
                  <div class="radiobox-itm">
                    <Checkbox id="city1" name="city" v-model="salesRateDetails" :binary="true" @click="searchSalesLatestRate"/>
                    <label for="city1">Prev Details</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-field p-col-4"></div>
        </div>
        <Dialog header="Do you want to select normal customer or regular customer?" :visible.sync="customerType"
                :style="{width: '75vw', height:'20vw'}" :modal="true" :contentStyle="{'overflow': 'visible'}">
          <template #footer>
            <Button label="No" icon="pi pi-times" @click="closeBasic" class="p-button-danger"/>
            <Button label="Yes" icon="pi pi-check" @click="closeBasic" class="p-button-success" autofocus/>
          </template>
        </Dialog>
        <div class="p-field p-col-12 p-md-12 genTable">
          <div class="p-datatable-responsive p-datatable-gridlines">
            <div class="scrollable">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">SN</th>
                    <th scope="col">Item Name</th>
                    <th scope="col">Hs Code</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Unit</th>
                    <th scope="col">Rate</th>
                    <th scope="col" v-if="this.$store.getters.modules.includes('5.39')">Commission</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inventoryInOutDetailList" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.itemMaster.itemNameWithCode }}</td>
                    <td>{{ item.itemMaster.hsCode }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.itemMaster.unitName }}</td>
                    <td>{{ item.rate }}</td>
                    <td v-if="$store.getters.modules.includes('5.39')">{{ item.commissionPerItem }}</td>
                    <td>{{ (item.rate * item.quantity).toFixed(4) }}</td>
                    <td>
                      <Button class="p-button-raised p-button-rounded p-button-success" @click="editItemDTO(item,index)" icon="pi pi-pencil"/>
                      <Button class="p-button-raised p-button-rounded p-button-danger" v-if="editDto" @click="removeItemFromDTO(item, index)" icon="pi pi-trash" disabled/>
                      <Button class="p-button-raised p-button-rounded p-button-danger" v-else-if="!editDto" @click="removeItemFromDTO(item, index)" icon="pi pi-trash"/>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="3">Total:</td>
                    <td>{{ totalQty }}</td>
                    <td colspan="2">&nbsp;</td>
                    <!-- <td v-if="this.$store.getters.modules.includes('5.39')" colspan="3"></td> -->
                    <td>{{ subTotal.toFixed(4) }}</td>
                    <td>&nbsp;</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-lg-4 p-xl-4">
            <label>Narration</label>
            <Textarea rows="6" v-model="narration"/>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-4">
                <label for="soldBy">Sold By:</label>
                <Dropdown id="soldBy" v-model="soldByID" :options="users" optionLabel="name" optionValue="id" placeholder="Select Sold By" />
              </div>
              <div class="p-field p-col-4">
                <label for="exclude">Exclude In Report:</label>
                <Checkbox id="exclude" v-model="exclude" :binary="true" />
              </div>
              <!-- <div class="p-field p-col-4" v-if="this.$store.getters.modules.includes('5.39')">
                <label for="exclude">Commission Amount:</label>
                <InputNumber id="minmaxfraction" v-model="commissionAmount" :minFractionDigits="2" :maxFracionDigits="4"/>
              </div> -->
            </div>
          </div>
          <div class="p-field p-col-12 p-lg-3 p-xl-2 mt-25">
            <Button icon="pi pi-refresh" label="Reset" class="p-button-warning" @click="reset"/>
          </div>
          <div class="p-field p-col-12 p-lg-3 p-xl-2 mt-25">
            <form>
              <Button class="p-button p-button-success addNewBtn btn-btm-0 width-auto" label="Extra Expenses" @click.prevent="openBasic" icon="pi pi-plus"/>
              <Dialog header="Extra Expenses" :visible.sync="displayBasic" :style="{width: '60vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'auto'}">
                <form>
                  <div class="p-fluid p-formgrid p-grid p-mt-2">
                    <div class="p-field p-col-12 p-md-9 p-lg-6 p-xl-3">
                      <label for="extraExpense">Extra Expenses Name</label>
                      <Dropdown
                        v-model="extraExpenses"
                        :options="extraExpensesList"
                        optionLabel="expensesName"
                        :filter="true"
                        placeholder="Select One"
                        id="extraExpense"
                        :showClear="true"
                      />
                    </div>
                    <div class="p-field p-col-12 p-md-3 p-lg-2 p-xl-2">
                      <extraExpensesDialog class="p-mt-5" v-tooltip.top="'Add Extra Expenses'"/>
                    </div>
                    <div class="p-field p-col-12 p-lg-4 p-xl-2">
                      <label for="extraExpensesAmt">Amount</label>
                      <InputText v-model="extraExpenseAmt" id="extraExpensesAmt"/>
                    </div>
                    <div class="p-field p-col-12 p-xl-2">
                      <div class="radiobox">
                        <div class="radiobox-itm">
                          <label for="applyVat">Apply Vat</label>
                          <InputSwitch v-model="applyVat"/>
                        </div>
                        <div class="radiobox-itm">
                          <label for="applyVat">Apply On Bill</label>
                          <InputSwitch v-model="applyExpensesOnBill"/>
                        </div>
                      </div>
                    </div>
                    <div class="p-field p-offset-7 p-col-5 p-lg-offset-0 p-lg-3">
                      <div class="p-fluid p-grid justify-content-end">
                        <div class="p-field p-col-6 p-mt-5">
                          <Button class="p-button-info btn-btm-0 width-auto p-button" @click.prevent="addExtraExpensesToList" :label="!editExtraExpenses?'Add':'Update'"/>
                        </div>
                        <div class="p-field p-col-6 p-mt-5" v-if="editExtraExpenses">
                          <Button class="p-button-danger" v-if="editExtraExpenses" @click.prevent="cancelExtraExpenses" label="Cancel"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <div class="p-datatable-responsive p-datatable-gridlines finalCalc">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>S.N</th>
                        <th>Expenses Name</th>
                        <th>Apply Vat</th>
                        <th>Amount</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-for="(expense,index) in inventoryExtraExpensesList" :key="index">
                      <tr>
                        <td>{{ index + 1 }}</td>
                        <td>{{ expense.extraExpense.expensesName }}</td>
                        <td>{{ expense.extraExpense.applyVat ? 'Yes' : 'No' }}</td>
                        <td>{{ expense.extraExpenseAmt }}</td>
                        <td>
                          <Button class="p-button-raised p-button-rounded p-button-success" @click.prevent="editExtraExpensesDto(expense,index)" icon="pi pi-pencil"/>
                          <Button class="p-button-raised p-button-rounded p-button-danger" v-if="editExtraExpenses" icon="pi pi-trash" @click.prevent="removeExtraExpense(expense, index)" disabled/>
                          <Button icon="pi pi-trash" class="p-button-raised p-button-rounded p-button-danger" v-else @click.prevent="removeExtraExpense(expense, index)"/>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <template #footer>
                  <Button icon="pi pi-save" class="p-button-raised p-button-success" @click.prevent="closeBasic" label="Save"/>
                  <Button @click.prevent="closeBasic" class="p-button-danger" label="Cancel"/>
                </template>
              </Dialog>
            </form>
          </div>
          <div class="p-field p-col-12 p-lg-9 p-xl-4">
            <div class="p-datatable-responsive p-datatable-gridlines finalCalc">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Subtotal</th>
                    <th></th>
                    <td>{{ subTotal.toFixed(4) }}</td>
                  </tr>
                  <tr>
                    <th>Discount</th>
                    <th>
                      <Button v-if="chooseDiscountPer" label="%" @click="chooseDisPercent"/>
                      <Button v-if="chooseDiscountAmt" label="RS" @click="chooseDisountAmt"/>
                    </th>
                    <td>
                      <InputText v-if="chooseDiscountPer" v-model="discountPer"/>
                      <InputText v-if="chooseDiscountAmt" v-model="discountAmt"/>
                    </td>
                  </tr>
                  <tr v-if="chooseDiscountPer">
                    <th>Discounted Amt:</th>
                    <th></th>
                    <td>{{ discountAmt }}</td>
                  </tr>
                  <tr>
                    <th>Taxable</th>
                    <th></th>
                    <td>{{ taxable.toFixed(4) }}</td>
                  </tr>
                  <tr>
                    <th>Non-taxable</th>
                    <th></th>
                    <td>{{ nonTaxable.toFixed(4) }}</td>
                  </tr>
                  <tr>
                    <th>Tax</th>
                    <th>13%</th>
                    <td>{{ tax.toFixed(4) }}</td>
                  </tr>
                  <tr>
                    <th>Total</th>
                    <th></th>
                    <td>{{ totalBillAmount.toFixed(4) }}</td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-6 p-md-4 p-xl-2 p-xl-offset-6">
            <Button icon="pi pi-save" :label="salesInvoice === undefined ? 'Save': 'Update'" class="p-button-success" @click="addSalesInvoice"/>
          </div>
          <div class="p-field p-col-6 p-md-2" v-if="salesInvoice!=undefined">
            <Button class="p-button-danger" @click="goBack()" label="Cancel"/>
          </div>
          <div class="p-field p-col-6 p-md-2">
            <Button class="p-button-info" label=" Print" icon="pi pi-print"/>
          </div>
          <div class="p-field p-col-6 p-md-4 p-xl-2">
            <Button icon="pi pi-download" label="Generate PDF" class="p-button-secondary" @click="printBill"/>
          </div>
        </div>
        </form>
      </div>
    </section>
  </template>

  <script>
  import Dropdown from 'primevue/dropdown'
  import DatePicker from 'vue2-datepicker'
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import InputText from 'primevue/inputtext'
  import $ from 'jquery'
  import InputSwitch from 'primevue/inputswitch'
  import Dialog from 'primevue/dialog'
  import AutoComplete from 'primevue/autocomplete'
  import InputNumber from 'primevue/inputnumber'
  import InputMask from 'primevue/inputmask'
  import customerDialog from '../accountDialog/CustomerAccountDialog'
  import warehouseDialog from '../warehouseDialog/warehouseDialog'
  import itemDialog from '../itemDialog/itemMasterDialog'
  import extraExpensesDialog from '../billSundryDialog/billSundrySalesDialog'
  import Button from 'primevue/button'
  import Textarea from 'primevue/textarea'
  import UniConversionDetail from '../commonDialogs/UnitConversionDetail'
  import Checkbox from 'primevue/checkbox'

  export default {
    name: 'salesInvoice',
    props: ['salesInvoice'],
    data() {
      return {
        warehouse: '',
        taxTypeList: [
          {name: 'Exclusive', code: 'Exclusive'},
          {name: 'Inclusive', code: 'Inclusive'},
          {name: 'Exempt', code: 'Exempt'}
        ],
        item: '',
        accountMaster: '',
        vendorName: '',
        quantity: 0,
        rate: 0,
        commissionPerItem: 0,
        cc: 0,
        foundRateOnItem: false,
        purchaseSalesDate: null,
        inventoryInOutDetailList: [],
        inventoryInOutDetailDeleteList: [],
        inventoryExtraExpensesList: [],
        inventoryExtraExpensesDeletedList: [],
        customerAccountList: [],
        purchaseListForSalesList: [],
        latestSalesRateList: [],
        variantDetailslist: [],
        customer: '',
        taxType: '',
        taxable: 0,
        creditDays: 0,
        tax: 0,
        unitConversion: '',
        alternateUnit: '',
        nonTaxable: 0,
        vatPercentage: '',
        salesMessage: '',
        editing: false,
        editDto: false,
        billNo: null,
        index: null,
        inventoryOutHeaderId: null,
        loading: true,
        id: null,
        itemSelected: '',
        totalQty: 0,
        total: 0,
        extraExpensesList: null,
        extraExpenseAmt: null,
        applyExpensesOnBill: false,
        displayBasic: false,
        extraExpenses: '',
        applyVat: false,
        editExtraExpenses: false,
        filteredItems: null,
        filterPurchase: null,
        discountPer: 0,
        discountAmt: 0,
        headerId: null,
        printDialog: false,
        isMultiUnit: false,
        savedBill: false,
        englishDateEnabled: true,
        creditLimitAmt: 0,
        customerType: false,
        narration: '',
        setWarehouseData: false,
        orderIdList: [],
        challanIdList: [],
        orderId: null,
        challanId: null,
        loadFromOrder: false,
        loadItemFromPurchase: false,
        loadFromChallan: false,
        loadType: '',
        chooseDiscountPer: true,
        chooseDiscountAmt: false,
        entryType: 'Items',
        purchaseDetailId: '',
        salesRateDetails: false,
        displayVarientsDetails: false,
        enableVarients: false,
        displayVarientsDialog: false,
        orderRefId: null,
        challanRefId: null,
        soldByID: null,
        exclude: false,
        commissionAmount: 0,
        users: []
      }
    },
    computed: {
      unitConversionLists() {
        return this.$store.state.itemgroup.unitConversionLists
      },
      warehouseLists() {
        return this.$store.state.warehouse.warehouseDropDownList
      },
      supplierAndCustomerList() {
        return this.$store.state.accountMaster.supplierCustomerCashList
      },
      itemMasterListByItemType() {
        return this.$store.state.itemMaster.itemMasterListByItemType
      },
      ifCash() {
        if (this.accountMaster.name === 'Cash' || this.accountMaster.name === 'cash') {
          return true
        }
      },
      ifNotCash() {
        if (this.accountMaster.name === 'Cash' || this.accountMaster === '') {
          return true
        }
      },
      totalAmount() {
        if (this.quantity > 0 && this.rate > 0) {
          let totalAmt = 0
          totalAmt = this.quantity * this.rate
          if (isNaN(totalAmt)) {
            totalAmt = 0
          }
          this.total = totalAmt
          return totalAmt
        } else {
          if (isNaN(this.total)) {
            this.total = 0
          }
        }
      },
      findRate() {
        if (isNaN(this.rate)) {
          this.rate = 0
        }
        if (isNaN(this.total)) {
          this.total = 0
        }
        if (isNaN(this.quantity)) {
          this.quantity = 0
        }
        if (parseFloat(this.rate) > 0) {
          this.foundRateOnItem = true
        }
        this.rate = (parseFloat(this.rate))
        this.total = (parseFloat(this.total))
        this.quantity = (parseFloat(this.quantity))
        let rates = 0
        if (this.total > 0 && this.quantity > 0) {
          rates = parseFloat(this.total) / parseFloat(this.quantity)
          this.rate = rates.toFixed(2)
        }
        if (isNaN(rates)) {
          rates = 0
        }
        if (isNaN(this.total)) {
          this.total = 0
        }
        return rates
      },
      setRateFromItem() {
        if (!this.editDto) {
          let rate = 0
          if (this.item !== undefined) {
            this.rate = this.item.salesRate
          } else {
            this.rate = 0
          }
          return rate
        }
      },
      subTotal() {
        let subTotal = 0
        let discount = 0
        let discountPerItem = 0
        let totalDiscountPerItem = 0
        this.taxable = 0
        this.tax = 0
        this.nonTaxable = 0
        this.totalQty = 0
        discount = this.discountAmt
        for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
          subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
          this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
          this.totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
          if (this.chooseDiscountPer === true) {
            if (this.discountPer > 100) {
              this.$toast.add({severity: 'error', summary: '', detail: 'Discount must be less than 100 %', life: 10000})
              return
            }
            this.discountAmt = (parseFloat(subTotal) * this.discountPer / 100).toFixed(4)
          }
          if (this.chooseDiscountAmt === true) {
            if (this.discountAmt === '') {
              this.discountAmt = 0.0
            }
          }
          switch (this.taxType) {
            case 'Exclusive':
              if (this.itemSelected.vatable) {
                this.tax = 0
                totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
                this.taxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity) - parseFloat(totalDiscountPerItem))
                this.tax += parseFloat(this.taxable * 0.13)
                this.addExtraExpenses()
              } else {
                totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
                this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity) - parseFloat(totalDiscountPerItem))
                this.addExtraExpenses()
              }
              break
            case 'Inclusive':
              if (this.itemSelected.vatable) {
                this.tax = 0
                let amtWithoutVat = ((subTotal * 100) / (100 + 13))
                this.taxable = parseFloat(amtWithoutVat)
                this.tax += (parseFloat(subTotal) - parseFloat(amtWithoutVat))
                this.addExtraExpenses()
              } else {
                totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
                this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity) - parseFloat(totalDiscountPerItem))
                this.addExtraExpenses()
              }
              break
            case 'Exempt':
              this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
              break
          }
        }
        this.nonTaxable -= discount
        return subTotal
      },
      totalBillAmount() {
        let totalBillAmount = 0.0
        totalBillAmount = parseFloat(this.taxable) + parseFloat(this.tax) + parseFloat(this.nonTaxable)
        return totalBillAmount
      }
    },
    mounted() {
      const promises = [
        this.supplierCustomerList(),
        this.itemMasterListByItemTypes(),
        this.warehouseList(),
        this.maxSalesBillNo(),
        this.supplierCustomerCashList(),
        this.extraSalesExpenses(),
        this.loadUsers()
      ]
      Promise.all(promises)
      .then(() => {
        if (this.salesInvoice !== undefined) {
          return this.editSales()
        }
      })
      .then(() => {
        this.loading = false
      })
      .catch((err) => {
        console.error('Error loading data:', err)
        this.loading = false
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load data',
          life: 10000
        })
      })
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.salesInvoice === undefined ||
          this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
      this.setWarehouse()
      this.findUnitConversionList()
    },
    methods: {
      async loadUsers() {
        try {
          const response = await this.$store.dispatch('loadUser')
          this.users = response.data.data
        } catch (error) {
          console.error('Failed to load users:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to load users',
            life: 3000
          })
        }
      },
      async findUnitConversionList() {
        await this.$store.dispatch('loadUnitConversionList')
      },
      setWarehouse() {
        if (this.$store.state.warehouseData.id > 0) {
          this.setWarehouseData = true
          this.warehouse = this.$store.state.warehouseData
        } else if (this.warehouseLists.length === 1) {
          this.warehouse = this.warehouseLists[0]
        }
      },
      addExtraExpenses() {
        if (this.inventoryExtraExpensesList.length > 0 & this.applyExpensesOnBill) {
          for (let i = 0; i < this.inventoryExtraExpensesList.length; i++) {
            if (this.inventoryExtraExpensesList[i].applyVat) {
              this.taxable += parseFloat(this.inventoryExtraExpensesList[i].extraExpenseAmt)
            } else {
              this.nonTaxable += parseFloat(this.inventoryExtraExpensesList[i].extraExpenseAmt)
            }
          }
        }
      },
      async supplierCustomerList() {
        let response = await this.$store.dispatch('loadCustomerSupplierListForDropdown')
        if (response.data.status === 'SUCCESS') {
          this.customerAccountList = response.data.data
        }
      },
      async warehouseList() {
        await this.$store.dispatch('loadWarehouseDropDown')
      },
      async supplierCustomerCashList() {
        await this.$store.dispatch('loadsupplierCustomerAndCashList')
      },
      async itemMasterListByItemTypes() {
        await this.$store.dispatch('loadItemMasterListByItemTypeSales')
      },
      async extraSalesExpenses() {
        let resp = await this.$store.dispatch('extraSalesExpenses')
        this.extraExpensesList = resp.data.data
      },
      async maxSalesBillNo() {
        let response = await this.$store.dispatch('maxSalesInvoiceBillNo')
        if (this.salesInvoice === undefined) {
          this.billNo = response.data.data
          this.salesMessage = response.data.message
          this.narration = response.data.message + '- ' + response.data.data
        } else {
          this.billNo = this.salesInvoice.billNo
          this.salesMessage = this.salesInvoice.remarks
        }
      },
      editItemDTO(data, index) {
        this.itemDTOreset()
        this.item = data.itemMaster
        this.rate = data.rate
        this.quantity = data.quantity
        this.commissionPerItem = data.commissionPerItem
        this.freeSales = data.freeSales
        this.total = (parseFloat(data.rate) * parseFloat(data.quantity)).toFixed(2)
        this.index = index
        this.editDto = true
        if (parseFloat(this.rate) > 0) {
          this.foundRateOnItem = true
        }
        if (data.id !== undefined) {
          this.id = data.id
        }
        this.focusInput()
      },
      amountProvided(data) {
        this.inventoryExtraExpensesList.push({...data})
      },
      addItemToDTOList() {
        if (this.rate === null) {
          this.rate = 0
        }
        if (this.item.bonusItem && this.rate === 0) {
          this.freeSales = true
          this.rate = this.item.salesRate * this.item.ccPercentage / 100
        }
        if (this.entryType === 'Purchase') {
          this.purchaseDetailId = this.item.id
          this.item.id = this.item.itemId
          this.item.bonusItem = this.item.bonusItem
        }
        if (this.$store.getters.modules.includes('5.32')) {
          if (this.item.minimumSalesRate < this.rate) {
            this.$toast.add({severity: 'error', summary: '', detail: 'Sales rate must be grater then minimum sales rate!', life: 10000})
            return
          }
        }
        let item = {
          itemId: this.item.id,
          itemMaster: this.item,
          quantity: this.quantity,
          freeSales: this.freeSales,
          rate: this.rate,
          id: this.id,
          purchaseDetailId: this.purchaseDetailId,
          itemPropertyValuesDTOList: this.variantDetailslist,
          commissionPerItem: this.commissionPerItem
        }
        if (this.taxType === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select Sales type!', life: 10000})
          return
        }
        if (this.accountMaster === '' || this.accountMaster === null) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select Sale to!', life: 10000})
          return
        }
        if (this.warehouse === '' || this.warehouse === null) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
          return
        }
        if (this.item.id === undefined) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
          return
        }
        if (this.item === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
          return
        } else if (this.quantity <= 0) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
          return
        } else if (!this.item.bonusItem && this.rate <= 0) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
          return
        }
        if (this.item.closingStock < 0) {
          this.$toast.add({severity: 'warn', summary: '', detail: 'Quantity is out of stock!', life: 10000})
        }
        if (!this.editDto) {
          this.inventoryInOutDetailList.push({...item})
        } else {
          this.inventoryInOutDetailList.splice(this.index, 1, {...item})
        }
        this.itemDTOreset()
        this.focusInput()
        this.loadFromItem(this.entryType)
      },
      closeBasicBatchDetails() {
        this.displayVarientsDialog = false
      },
      addExtraExpensesToList() {
        if (this.extraExpenses === '') {
          this.$toast.add({severity: 'warn', summary: '', detail: 'Please select Extra expense account!', life: 10000})
          return
        }
        let extraExpense = {
          extraExpense: this.extraExpenses,
          id: this.extraExpenses.id,
          extraExpenseAmt: this.extraExpenseAmt
        }
        if (!this.editExtraExpenses) {
          this.inventoryExtraExpensesList.push({...extraExpense})
        } else {
          this.inventoryExtraExpensesList.splice(this.index, 1, {...extraExpense})
        }
        this.editExtraExpenses = false
        this.resetExtraExpenses()
      },
      editExtraExpensesDto(data, index) {
        this.resetExtraExpenses()
        this.extraExpenses = data.extraExpense
        this.editExtraExpenses = true
        this.index = index
        this.extraExpenseAmt = data.extraExpenseAmt
        if (data.extraExpense.id != null) {
          this.id = data.extraExpense.id
        }
      },
      removeExtraExpense(data, index) {
        if (this.editing) {
          this.inventoryExtraExpensesDeletedList.push({...data})
        }
        this.inventoryExtraExpensesList.splice(index, 1)
      },
      cancelExtraExpenses() {
        this.editExtraExpenses = false
        this.resetExtraExpenses()
      },
      async addSalesInvoice() {
        if (this.purchaseSalesDate === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please enter date!', life: 10000})
          return
        }
        const creditLimitAndDueAmt = parseFloat(this.accountMaster.closingBalance) + parseFloat(this.creditLimitAmt)
        if (creditLimitAndDueAmt < this.totalBillAmount) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Transaction amount exceeds credit limit amount!',
            detail: '',
            life: 10000
          })
        }
        let response = ''
        let salesInvoice = {
          billNo: this.billNo,
          warehouseId: this.warehouse.id,
          accountMasterId: this.accountMaster.id,
          purchaseSalesDate: this.purchaseSalesDate,
          purchaseSalesDateNepali: this.purchaseSalesDate,
          cashTransactionId: this.customer.id,
          fiscalYearId: this.$store.state.fyId,
          taxType: this.taxType,
          remarks: this.narration,
          billToName: this.vendorName,
          itemLoadFrom: this.entryType,
          id: this.inventoryOutHeaderId,
          discountPercentage: this.discountPer,
          discount: this.discountAmt,
          subTotalAmount: this.subTotal,
          sumOfQuantity: this.totalQty,
          applyExpensesOnBill: this.applyExpensesOnBill,
          inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList,
          inventoryInOutDetailList: this.inventoryInOutDetailList,
          inventoryExtraExpensesList: this.inventoryExtraExpensesList,
          orderRefId: this.orderRefId,
          challanRefId: this.challanRefId,
          soldByID: this.soldByID,
          exclude: this.exclude,
          commissionAmount: this.commissionAmount,
          creditDays: this.creditDays
        }
        if (salesInvoice.inventoryInOutDetailList.length <= 0) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
          return
        }
        if (this.discountPer > 100) {
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: 'Discount percentage cannot be greater than 100!',
            life: 10000
          })
          return
        }
        if (this.salesInvoice === undefined || !this.editing) {
          try {
            this.loading = true
            response = await this.$store.dispatch('addSalesInvoice', salesInvoice)
            this.loading = false
          } catch (e) {
            this.loading = false
            this.$toast.add({
              severity: 'error',
              summary: '',
              detail: 'Something went wrong!Please contact our support team',
              life: 5000
            })
          }
        } else {
          try {
            this.loading = true
            response = await this.$store.dispatch('updateSalesInvoice', salesInvoice)
            this.loading = false
          } catch (e) {
            this.loading = false
            this.$toast.add({
              severity: 'error',
              summary: '',
              detail: 'Something went wrong!Please contact our support team',
              life: 5000
            })
          }
          let status = {
            message: response.data.message
          }
          this.$router.push({name: 'Sales Invoice Report', params: {status}})
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
          await this.maxSalesBillNo()
          this.itemMasterListByItemTypes()
          this.supplierCustomerList()
          this.supplierCustomerCashList()
          this.savedBill = true
          this.loading = false
          if (this.$store.state.ablePrintRealTime) {
            this.openPrintDialog(response.data.data.id)
          }
          console.log('this.$store.state.ablePrintRealTime' + this.$store.state.ablePrintRealTime)
          this.reset()
        } else {
          this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
        }
      },
      set_data_warehouse(data) {
        let warehouse = {
          id: data.id,
          name: data.name
        }
        this.warehouse = warehouse
        this.warehouseList()
      },
      set_data_item(data) {
        this.itemMasterListByItemTypes()
        data.itemNameWithCode = data.name
        this.item = data
        this.item.itemNameWithCode = this.item.name
      },
      set_customer_master(data) {
        this.supplierCustomerList()
        this.accountMaster = data
      },
      editSales() {
        this.editing = !this.editing
        if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
          this.purchaseSalesDate = this.salesInvoice.purchaseSalesDateNepali
        } else {
          this.purchaseSalesDate = this.salesInvoice.purchaseSalesDate
        }
        this.discountPer = this.salesInvoice.discountPercentage
        this.discountAmt = this.salesInvoice.discount
        this.taxType = this.salesInvoice.vatTypeEnum
        this.warehouse = this.salesInvoice.warehouse
        this.narration = this.salesInvoice.remarks
        this.creditDays = this.salesInvoice.creditDays
        this.inventoryOutHeaderId = this.salesInvoice.id
        this.entryType = this.salesInvoice.itemLoadFrom
        if (this.salesInvoice.accountMaster && this.supplierAndCustomerList) {
          const matchingAccount = this.supplierAndCustomerList.find(
            account => account.id === this.salesInvoice.accountMaster.id
          )
          if (matchingAccount) {
            this.accountMaster = matchingAccount
          }
        }
        if (this.users) {
          const matchingAccount = this.users.find(
            user => user.name === this.salesInvoice.soldBy
          )
          if (matchingAccount) {
            this.soldByID = matchingAccount.id
          }
        }
        if (this.salesInvoice.cashTransactionId !== undefined) {
          this.customer = this.salesInvoice.cashTransactionId
        }
        this.vendorName = this.salesInvoice.billToName
        this.inventoryInOutDetailList = this.salesInvoice.inventoryInOutDetailList
        this.inventoryExtraExpensesList = this.salesInvoice.inventoryExtraExpensesListForReport
        this.variantDetailslist = this.salesInvoice.variantDetailslist
        this.exclude = this.salesInvoice.exclude || false
        this.loadFromItem(this.entryType)
        this.chooseDiscountAmt = false
        this.commissionAmount = this.salesInvoice.commissionAmount
      },
      removeItemFromDTO(data, id) {
        if (this.editing && data.id !== null) {
          this.inventoryInOutDetailDeleteList.push({...data})
        }
        this.inventoryInOutDetailList.splice(id, 1)
        this.totalBillAmount = 0
        this.taxable = 0
        this.tax = 0
        this.nonTaxable = 0
      },
      itemDTOreset() {
        this.item = ''
        this.rate = 0
        this.quantity = 0
        this.commissionPerItem = 0
        this.freeSales = false
        this.total = 0
        this.editDto = false
        this.id = null
        this.foundRateOnItem = false
        this.purchaseDetailId = ''
        this.enableVarients = false
      },
      openBasic() {
        this.displayBasic = true
      },
      closeBasic() {
        this.displayBasic = false
      },
      closeSalesRatesLatest() {
        this.salesRateDetails = false
      },
      resetExtraExpenses() {
        this.extraExpenses = ''
        this.applyVat = false
        this.extraExpenseAmt = ''
        this.applyExpensesOnBill = false
      },
      reset() {
        this.itemDTOreset()
        this.warehouse = ''
        this.accountMaster = ''
        this.items = ''
        this.discountPer = 0
        this.creditDays = 0
        this.discountAmt = 0
        this.quantity = 0
        this.freeSales = false
        this.rate = 0
        this.creditLimitAmt = 0
        this.entryType = 'Items'
        if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
          this.setNepaliDate()
        } else {
          this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
        }
        this.taxType = ''
        this.inventoryInOutDetailList = []
        this.vendorName = ''
        this.inventoryExtraExpensesList = []
        this.enableVarients = false
        this.soldByID = null
        this.exclude = false
        this.commissionAmount = 0
      },
      isNumber(evt) {
        evt = window.event
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      setNepaliDate() {
        if (this.salesInvoice === undefined) {
          this.purchaseSalesDate = this.$store.getters.nepaliNewDate
        }
      },
      nepaliDate() {
        $('#purchaseSalesDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.purchaseSalesDate = $('#purchaseSalesDate').val()
          }
        })
      },
      searchItem(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filteredItems = [...this.itemMasterListByItemType]
          } else {
            this.filteredItems = this.itemMasterListByItemType.filter((item) => {
              return item.name.toLowerCase().includes(event.query.toLowerCase()) || item.itemCode.includes(event.query)
            })
          }
        }, 250)
      },
      searchPurchaseItem(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filterPurchase = [...this.purchaseListForSalesList]
          } else {
            this.filterPurchase = this.purchaseListForSalesList.filter((item) => {
              return item.name.toLowerCase().startsWith(event.query.toLowerCase())
            })
          }
        }, 250)
      },
      async searchSalesLatestRate() {
        let sales = {
          customerId: this.accountMaster.id,
          itemId: this.item.id
        }
        let res = await this.$store.dispatch('loadLatestSalesRate', sales)
        this.latestSalesRateList = res.data.data
        this.salesRateDetails = true
      },
      async searchItemVariantDetails() {
        if (this.loadItemFromPurchase) {
          let sales = {
            itemId: this.item.id
          }
          let res = await this.$store.dispatch('loadvariantDetailsList', sales)
          this.variantDetailslist = res.data.data
          this.displayVarientsDialog = true
        }
      },
      printBill() {
        let salesInvoice = {
          id: this.headerId,
          type: 'printSalesBill',
          report: 'salesInvoice'
        }
        this.printDialog = false
        this.$store.dispatch('exportToPdf', salesInvoice)
        this.focusAfterSave()
        this.savedBill = false
      },
      openPrintDialog(data) {
        this.printDialog = true
        this.headerId = data
      },
      closePrintDialog() {
        this.printDialog = false
      },
      setEnglishDate() {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      },
      checkEnglish() {
        if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
          this.englishDateEnabled = true
          return
        } else {
          this.englishDateEnabled = false
          return
        }
      },
      focusInput() {
        this.$refs.itm.focus()
      },
      focusAfterSave() {
        this.$refs.tran.focus()
      },
      goBack() {
        if (this.inventoryInOutDetailDeleteList.length > 0) {
          this.salesInvoice.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
        }
        this.$router.back()
      },
      async getCreditLimitAmount() {
        let resp = await this.$store.dispatch('getCreditLimitAmount', this.accountMaster.id)
        this.creditLimitAmt = resp.data.data
        if (this.accountMaster.isCashAccount) {
          this.customerType = true
        }
      },
      async loadFrom(data) {
        if (data === 'order') {
          this.loadFromOrder = true
          this.loadFromChallan = false
          let orderIds = await this.$store.dispatch('loadSalesOrderIdList')
          this.orderIdList = orderIds.data.data
        }
        if (data === 'challan') {
          this.loadFromChallan = true
          this.loadFromOrder = false
          let challanIds = await this.$store.dispatch('loadSalesChallanIdList')
          this.challanIdList = challanIds.data.data
        }
      },
      async loadFromItem(data) {
        this.loading = true
        if (data === 'Items') {
          this.loadItemFromPurchase = false
        }
        if (data === 'Purchase') {
          let dat = {
            warehouse: this.warehouse.id
          }
          let rep = await this.$store.dispatch('loadPurchaseListForSales', dat)
          this.purchaseListForSalesList = rep.data.data
          this.loadItemFromPurchase = true
          this.enableVarients = true
        }
        this.loading = false
      },
      async loadSalesOrderDataWithOrderNo(orderNo) {
        let response = await this.$store.dispatch('loadDataWithSalesOrderId', orderNo)
        if (response.data.data.length > 0) {
          response.data.data.forEach(data => {
            if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
              this.purchaseSalesDate = data.purchaseDate
            } else {
              this.purchaseSalesDate = data.purchaseDate
            }
            this.accountMaster = data.accountMaster
            this.warehouse = data.warehouse
            this.orderRefId = data.id
            this.inventoryInOutDetailList = data.inventoryInOutDetailList
          })
        }
      },
      async loadSalesOrderDataWithChallanNo(challan) {
        let response = await this.$store.dispatch('loadDataWithSalesChallanNo', challan)
        if (response.data.data.length > 0) {
          response.data.data.forEach(data => {
            if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
              this.purchaseSalesDate = data.purchaseSalesDateNepali
            } else {
              this.purchaseSalesDate = data.purchaseDate
            }
            this.accountMaster = data.accountMaster
            this.warehouse = data.warehouse
            this.inventoryInOutDetailList = data.inventoryInOutDetailList
            this.challanRefId = data.id
          })
        }
      },
      chooseDisPercent() {
        this.chooseDiscountPer = false
        this.chooseDiscountAmt = true
        this.discountPer = 0
      },
      chooseDisountAmt() {
        this.chooseDiscountAmt = false
        this.chooseDiscountPer = true
        this.discountAmt = 0
      },
      openConversionDialog(unitConver) {
        let unitConversion = {
          uniConversion: unitConver,
          isPurchaseSales: 'sales'
        }
        this.$refs.conversionDialog.openDialog(unitConversion)
      }
    },
    components: {
      Dropdown,
      DatePicker,
      DataTable,
      Column,
      InputText,
      InputSwitch,
      Dialog,
      AutoComplete,
      InputNumber,
      InputMask,
      customerDialog,
      warehouseDialog,
      itemDialog,
      extraExpensesDialog,
      Button,
      Textarea,
      UniConversionDetail,
      Checkbox
    }
  }
  </script>

  <style scoped src="@../../../static/css/purchase.css">
  </style>



// WEBPACK FOOTER //
// salesinvoice.vue?04c188a8